import React, { useState } from "react";
import { connect } from "react-redux";
import { Mutation } from "react-apollo";

import cancelRegistrationMutation from "../../../gql/cancelRegistrationMutation";
import { toastTranslated } from "../../../toastr/toastr";
import transError from "../../../i18n/fieldError";
import CancelButton from "./CancelButton";
import SuccessModal from "./SuccessModal";
import ConfirmationModal from "./ConfirmationModal";
import { ROLE_SYSTEM_ADMINISTRATOR } from "../../../security/role";
import Cancel from "../details/registrations/Cancel";

// Cancel Container is used for Members on the coursePlan as well as for the admin under members/registrations
function CancelContainer({
  trainingUnitId,
  courseTitle,
  trainingUnitDate,
  isOnWaitingList,
  canCancel,
  memberId,
  myRole,
  myAccountId,
  onFinished
}) {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [wasOnWaitingList] = useState(isOnWaitingList);
  const cancelMemberId = memberId ? memberId : myAccountId;

  const isAdminView = myRole === ROLE_SYSTEM_ADMINISTRATOR;

  const handleCancel = mutateFunc => () => {
    mutateFunc({
      variables: {
        input: {
          trainingUnitId: trainingUnitId,
          memberId: cancelMemberId
        }
      }
    }).then(({ data: { result } }) => {
      if (result.error) {
        result.error.errors.forEach(error => {
          toastTranslated(
            "error",
            transError(`cancelRegistration.${error.code}`, error.arguments)
          );
        });

        return;
      }

      // for admins to display correct styled success-message
      isAdminView &&
        toastTranslated("success", "coursePlan.events.registrationCancelled");
      isAdminView && onFinished();

      // for members to display correct styled success-message
      !isAdminView && setShowConfirmationModal(false);
      !isAdminView && setShowSuccessModal(true);
    });
  };

  const closeSuccessModal = () => {
    if (onFinished) {
      onFinished();
    }

    setShowSuccessModal(false);
  };

  const closeConfirmationModal = () => {
    if (onFinished) {
      onFinished();
    }

    setShowConfirmationModal(false);
  };

  return (
    <Mutation mutation={cancelRegistrationMutation} ignoreResults={false}>
      {mutateFunc => (
        <>
          {/* Use different Cancel Buttons to match styling of page */}
          {isAdminView ? (
            <Cancel
              onCancel={handleCancel(mutateFunc)}
              trainingUnitId={trainingUnitId}
              memberId={memberId}
            />
          ) : (
            <CancelButton
              onSubmit={() => setShowConfirmationModal(true)}
              canCancel={canCancel}
              isOnWaitingList={isOnWaitingList}
            />
          )}

          {showConfirmationModal && !isAdminView && (
            <ConfirmationModal
              courseTitle={courseTitle}
              trainingUnitDate={trainingUnitDate}
              onConfirm={handleCancel(mutateFunc)}
              onClose={closeConfirmationModal}
              isAdminView={isAdminView}
            />
          )}
          {showSuccessModal && !isAdminView && (
            <SuccessModal
              courseTitle={courseTitle}
              wasOnWaitingList={wasOnWaitingList}
              onClose={closeSuccessModal}
              isAdminView={isAdminView}
            />
          )}
        </>
      )}
    </Mutation>
  );
}

CancelContainer.displayName = "coursePlan/cancel/CancelContainer";

const mapStateToProps = ({ auth: { accountId, role } }) => ({
  myRole: role,
  myAccountId: accountId
});

export default connect(mapStateToProps)(React.memo(CancelContainer));
